import component from './component';
import { mainNav, relocationNav, mortgageNav } from './fixtures';

export default component;

export { component, mainNav, relocationNav, mortgageNav };
